import { LoadablePaint } from '@confluence/loadable';

export const ForgeFullPageExtensionPoint = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FullPage" */ './FullPage')).FullPage,
});
